import { Switch, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import Card from '../../components/partials/Card';
import PageHeader from '../../components/partials/PageHeader';

const CreateProduct = () => {

	const breadcrumbs = [
		<Link key='1' color='inherit' to='/'>
			Dashboard
		</Link>,
		<Link key='2' color='inherit' to='/products'>
			Products
		</Link>,
		<Typography key='3' color='text.primary'>
			Create Product
		</Typography>,
	];
	return (
		<>
			<PageHeader pageTitle='Create Product' breadcrumbs={breadcrumbs} />

			<Card title='New Product' className='pb-5 md:w-1/2'>
				<form>
					<div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
						<div className='my-2'>
							<label
								htmlFor='title'
								className='font-semibold text-gray-600 text-lg'
							>
								Title
							</label>
							<input
								className='form-input'
								type='text'
								id='title'
								placeholder='Type title ...'
							/>
						</div>
						<div className='my-2'>
							<label
								htmlFor='image'
								className='font-semibold text-gray-600 text-lg'
							>
								Image (URL)
							</label>
							<input
								className='form-input'
								type='text'
								id='image'
								placeholder='Type image ...'
							/>
						</div>
						<div className='my-2'>
							<label
								htmlFor='stock'
								className='font-semibold text-gray-600 text-lg'
							>
								Stock
							</label>
							<input
								className='form-input'
								type='number'
								id='stock'
								placeholder='Type stock ...'
							/>
						</div>
						<div className='my-2'>
							<label
								htmlFor='price'
								className='font-semibold text-gray-600 text-lg'
							>
								Price
							</label>
							<input
								className='form-input'
								type='number'
								id='price'
								placeholder='Price ..'
							/>
						</div>
					</div>

					<div className='my-2'>
						<label
							htmlFor='status'
							className='font-semibold text-gray-600 text-lg'
						>
							Status
						</label>
						<div className='flex justify-between items-center'>
							<span>Product Active ?</span>
							<Switch defaultChecked />
						</div>
					</div>
					<button
						type='submit'
						className='button-dark py-2 w-full text-xl'
					>
						CREATE
					</button>
				</form>
			</Card>
		</>
	);
};

export default CreateProduct;
